<template>
	<div>
		<p>
			<button type="button" class="btn btn-primary" @click="addEvent">Добавить новость</button>
		</p>
			<div v-for="(eventData, key) in eventDatas" :key="key">
			Дополнительная новость № {{eventData.id}}
				<div class="row">
				<div class="col-md-3">
				<img :src="eventData.logo" width="100%" id="logo">
				</div>
				<div class="col-md-5">
				<div class="input-group mb-1 mr-sm-2">
					<div class="input-group-prepend">
					<div class="input-group-text">Заголовок</div>
					</div>
					<input type="text" class="form-control" v-model="eventData.subject">
				</div>
				<div class="input-group mb-1 mr-sm-2">
					<div class="input-group-prepend">
					<div class="input-group-text">Ссылка</div>
					</div>
					<input type="text" class="form-control" v-model="eventData.url">
				</div>
				<div class="input-group mb-1 mr-sm-2">
					<div class="input-group-prepend">
					<div class="input-group-text">Рубрика</div>
					</div>
					<select class="form-control" v-model="eventData.rubric" @change="select(eventData.id, eventData.rubric)">
						<option
						v-for="eventWpCategorys in eventWpCategory"
						:key="eventWpCategorys.id"
						v-bind:value="eventWpCategorys.name"
						:selected="eventData.rubric"
						>
							{{ eventWpCategorys.name }}
						</option>
					</select>
				</div>
				<div class="form-group">
				<div class="custom-file">
						<input type="file"
							class="custom-file-input"
							:data-id="eventData.id"
							id="customFile"
							@change="onAttachmentChange"
						>
						<label class="custom-file-label" for="customFile">Выбрать фоновую картинку</label>
				</div>
			</div>
						Активирована <input type="checkbox"  true-value="1"  false-value="0" v-model="eventData.is_active"> |
						Активирована для всех <input type="checkbox"  true-value="1"  false-value="0" v-model="eventData.fix">
				</div>
			</div>
			</div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			eventDatas: [],
			eventWpCategory: [],
			type: 0,
			images: null,
			selectCategory: null
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	created () {
		this.getEvent()
		this.getWpCategory()
	},
	methods: {
		select (id, rubric) {
			this.eventDatas.forEach(eventData => {
				if (parseInt(id) === parseInt(eventData.id)) {
					this.eventWpCategory.forEach(category => {
						if (rubric === category.name) {
							eventData.rubric_url = category.link
						}
					})
				}
			})
		},
		getEvent () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/mailing/events/' + this.id + '?type=0', {}, {
			}).then(function (response) {
				this.eventDatas = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		getWpCategory () {
			this.$http.get('https://turov.pro/wp-json/wp/v2/categories?per_page=50', {}, {
			}).then(function (response) {
				this.eventWpCategory = response.body
			}, function (response) {
			})
		},
		addEvent: function () {
			const formData = new FormData()
			formData.append('id', this.id)
			formData.append('type', this.type)
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/mailing/events', formData, {}, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
				const bodyData = response.body
				this.eventDatas.push(bodyData)
			}, function (response) {
			})
		},
		saveEvent: function () {
			this.$store.commit('CALL_API_ON')
			this.$http.put(this.$store.state.apiURL + '/v1/mailing/events/' + this.id, this.eventDatas, {}, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		onAttachmentChange (e) {
			var id = e.target.dataset.id
			if (e.target.files && e.target.files[0]) {
				var reader = new FileReader()
				this.eventDatas.forEach(eventData => {
					if (parseInt(id) === parseInt(eventData.id)) {
						reader.onload = function (e) {
							eventData.logo = e.target.result
							console.log(e.target)
						}
					}
				})
				reader.readAsDataURL(e.target.files[0])
			}
			this.attachment = e.target.files[0]
			const config = { 'content-type': 'multipart/form-data' }
			const formData = new FormData()
			formData.append('id', this.id)
			formData.append('type_id', id)
			formData.append('file', this.attachment)
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/mailing/uploads', formData, config, {
			}).then(function (response) {
				this.headerImage = response.body.file_url
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		back () {
			history.back()
			return false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/mailing/News.vue